import { Route, useHistory } from "react-router-dom";
import Navbar from "./components/Navbar";
import DefineAssortment from "./components/assortmentHierarcy/DefineAssortment";
import AddForm from "./components/assortmentHierarcy/AddForm";
import EditForm from "./components/assortmentHierarcy/EditForm";
import DefineSubCategory from "./components/assortmentSubcat/DefineSubCategory";
import AddSubcatForm from "./components/assortmentSubcat/AddSubcatForm";
import EditSubcatForm from "./components/assortmentSubcat/EditSubcatForm";
import DefineCategory from "./components/assortmentCategory/DefineCategory";
import EditCategoryForm from "./components/assortmentCategory/EditCategoryForm";
import AddCategoryForm from "./components/assortmentCategory/AddCategoryForm";
import AddFixture from "./components/fixtures/AddFixture";
import EditFixture from "./components/fixtures/EditFixture";
import PlanogramExcel from "./components/fixtures/PlanogramExcel";
import ImportPlanogram from "./components/assortmentPlanogram/ImportPlanogram";
import ViewPlanogram from "./components/assortmentPlanogram/ViewPlanogram";
import EditPlanogram from "./components/assortmentPlanogram/EditPlanogram";
import UpdateLimitless from "./components/fixtures/UpdateLimitless";
import RestrictSubcategory from "./components/assortmentPlanogram/RestrictSubcategory";
import { Security, SecureRoute, LoginCallback } from "@okta/okta-react";
import { OktaAuth, toRelativeUrl } from "@okta/okta-auth-js";
import Login from "./Login";
import config from "./config";
import Home from "./utils/Home";
import AddPlanogram from "./components/assortmentPlanogram/AddPlanogram";

const oktaAuth = new OktaAuth(config.oidc);
function App() {

  const history = useHistory();

  const customAuthHandler = () => {
    history.push("/login");
  };

  const restoreOriginalUri = async (_oktaAuth, originalUri) => {
    history.replace(toRelativeUrl(originalUri || "", window.location.origin));
  };

  return (

    <Security
      oktaAuth={oktaAuth}
      onAuthRequired={customAuthHandler}
      restoreOriginalUri={restoreOriginalUri}
    >
      <Navbar />
      <Route path="/" exact component={Home} />
      <SecureRoute path="/asssortment" component={DefineAssortment} />
      <SecureRoute path="/asssortment-hierarcy/add" component={AddForm} />
      <SecureRoute
        path="/edit-asssortment-hierarcy/:editID"
        component={EditForm}
      />
      <SecureRoute path="/category" component={DefineCategory} />
      <SecureRoute path="/asssortment-category/add" component={AddCategoryForm} />
      <SecureRoute
        path="/edit-asssortment-category/:catID"
        component={EditCategoryForm}
      />
      <SecureRoute path="/sub-category" component={DefineSubCategory} />
      <SecureRoute
        path="/asssortment-sub-category/add"
        component={AddSubcatForm}
      />
      <SecureRoute
        path="/edit-asssortment-sub-category/:subcatID"
        component={EditSubcatForm}
      />
      <SecureRoute path="/fixtures" component={PlanogramExcel} />
      <SecureRoute path="/fixture-add/:addID" component={AddFixture} />
      <SecureRoute path="/edit-fixture/:updateID" component={EditFixture} />
      <SecureRoute path="/update-limit/:limitID" component={UpdateLimitless} />
      <SecureRoute path="/import-planogram" component={ImportPlanogram} />
      <SecureRoute path="/view-planogram" component={ViewPlanogram} />
      <SecureRoute path="/edit-planogram/:planoID" component={EditPlanogram} />
      <SecureRoute path="/assign-planogram" component={AddPlanogram} />
      <SecureRoute path="/subcategory-restrict" component={RestrictSubcategory} />
      <Route path="/login" component={Login} />
      <Route path="/login/callback" component={LoginCallback} />

    </Security>

  );
}

export default App;
